const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "RADAR_BAND_TYPES_RETRIEVED":
            return action.availableRadarBandTypes;

        default:
            return state;
    }
}
